import { Component, computed, inject, output } from '@angular/core';
import {
  SiContentActionBarComponent,
  ContentActionBarMainItem
} from '@siemens/element-ng/content-action-bar';

import { LayersConfigService } from '../../services/layers-config.service';

/**
 * Viewport controls: zoom and layer selection.
 *
 * Leaflet's own zoom control is disabled in favour of this, so the map has a single
 * visual language. Labels stay as keys: the action bar translates them itself.
 */
@Component({
  selector: 'app-map-view-controls',
  imports: [SiContentActionBarComponent],
  templateUrl: './map-view-controls.component.html'
})
export class MapViewControlsComponent {
  readonly zoomIn = output<void>();
  readonly zoomOut = output<void>();

  private readonly layersConfig = inject(LayersConfigService);

  /** Layers are a group so the dropdown carries its own icon rather than the generic toggle. */
  readonly primaryActions = computed<ContentActionBarMainItem[]>(() => {
    const activeBaseLayerId = this.layersConfig.activeBaseLayerId();
    const activeOverlayIds = this.layersConfig.activeOverlayIds();

    return [
      {
        type: 'action',
        iconOnly: true,
        label: 'BROUTER_MAP.ZOOM_IN',
        icon: 'element-zoom-in',
        action: () => this.zoomIn.emit()
      },
      {
        type: 'action',
        iconOnly: true,
        label: 'BROUTER_MAP.ZOOM_OUT',
        icon: 'element-zoom-out',
        action: () => this.zoomOut.emit()
      },
      {
        type: 'group',
        iconOnly: true,
        label: 'BROUTER_MAP.LAYERS.TITLE',
        icon: 'element-map-location',
        children: [
          {
            type: 'radio-group',
            children: [
              { type: 'header', label: 'BROUTER_MAP.LAYERS.BASE' },
              ...this.layersConfig.baseLayers.map(layer => ({
                type: 'radio' as const,
                label: layer.name,
                checked: activeBaseLayerId === layer.id,
                action: () => this.layersConfig.setActiveBaseLayer(layer.id)
              }))
            ]
          },
          { type: 'divider' },
          { type: 'header', label: 'BROUTER_MAP.LAYERS.OVERLAYS' },
          ...this.layersConfig.overlays.map(layer => ({
            type: 'checkbox' as const,
            label: layer.name,
            checked: activeOverlayIds.includes(layer.id),
            action: () => this.layersConfig.toggleOverlay(layer.id)
          }))
        ]
      }
    ];
  });
}
